import { mainColor } from "../../Util/Colors";

import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import DoubleBar from "../Elements/DoubleBar";
import ComponentHeader from "../Header/ComponentHeader";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import { oppositeColor, secondaryColor } from "../../Util/Colors";
import {
  FiguresWrapper,
  HeadingMunicipality
} from "../../Util/StyleProps";
import EmptySpace from "../Elements/EmptySpace";
import { valuePairToPercent, isCurrentYear } from "../../Helpers/CommonHelper";
import { useInView } from "react-intersection-observer";

const BirthPlaceContainer = props => {
  const { data, sweden, blockColor, scroll } = props;
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true
  });
  let valueData = [];
  let valueArr = [];
  let swedenArr, swedenString;
  const lastYear = sweden.birthplace.year;

  swedenArr = valuePairToPercent(
    sweden.birthplace,
    ["borninsweden", "bornabroud"],
    1
  );
  swedenString = `Av hela Sveriges befolkning är ${swedenArr.pstring1} procent födda i Sverige och ${swedenArr.pstring2} procent födda utomlands (${lastYear}).`;

  data.forEach((item, i) => {
    if (item) {
      valueData.push(
        valuePairToPercent(item, ["borninsweden", "bornabroud"], 1)
      );
      valueArr.push(valueData[i].value1);
      valueArr.push(valueData[i].value2);
    }
  });

  let municipality1 = valueData[0];
  let municipality2 = valueData[1];
  const max = Math.max(...valueArr);
  const maxColumnPairIdx = valueArr.indexOf(Math.max(...valueArr));
  const maxIsEven = maxColumnPairIdx % 2 == 0;

  const maxOffset = max;
  const height = 300;
const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 20px 32px;
  text-align: center;
  font-family: 'Inter';
  font-weight: 700;
  width: fit-content;
  margin: auto auto 8px;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
  }
`;
const DoubleBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  place-content: space-between;
  .rect{
    flex-wrap: wrap;
  }
  @media${device.laptop} {
    .rect{
      flex-direction: nowrap;
    }
  }
  .label{
    text-align: center;
    margin-top: 8px;
    font-family: 'Inter';
    font-weight: 700;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;
  const width = 100;
  const topSpace = 63;

  let captions = ["Födda i Sverige", "Födda utomlands"];

  // Accessibility
  const ariaLabel = municipality => {
    const str = municipality
      ? isCurrentYear(municipality.year)
        ? "är"
        : "var"
      : "";

    return municipality
      ? `I ${municipality.name} kommun så ${str} ${municipality.value1} procent av befolkningen födda i Sverige och ${municipality.value2} procent födda utomlands. (år ${municipality.year})`
      : "";
  };

  const svgAriaLabel = municipality =>
    municipality
      ? `Det här stapeldiagramet gör jämförelser i procent för antal personer födda i Sverge och utomlands. För ${municipality.name} kommun.`
      : "";

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M50.5892 70.5767C49.3497 70.5767 48.2953 70.1353 47.4258 69.2525C46.5564 68.3703 46.1217 67.3094 46.1217 66.07C46.1217 64.8306 46.5631 63.7761 47.4458 62.9067C48.3281 62.0372 49.3889 61.6025 50.6283 61.6025C51.8678 61.6025 52.9222 62.0439 53.7917 62.9267C54.6611 63.8089 55.0958 64.8697 55.0958 66.1092C55.0958 67.3486 54.6545 68.4031 53.7717 69.2725C52.8895 70.1419 51.8286 70.5767 50.5892 70.5767ZM21.5717 70.5767C20.3528 70.5767 19.3056 70.1353 18.43 69.2525C17.5539 68.3703 17.1158 67.3094 17.1158 66.07C17.1158 64.8306 17.56 63.7761 18.4483 62.9067C19.3367 62.0372 20.3931 61.6025 21.6175 61.6025C22.8681 61.6025 23.9261 62.0439 24.7917 62.9267C25.6572 63.8089 26.09 64.8697 26.09 66.1092C26.09 67.3486 25.6522 68.4031 24.7767 69.2725C23.9017 70.1419 22.8333 70.5767 21.5717 70.5767ZM23.7692 57.0508C22.6914 57.0508 21.9347 56.5722 21.4992 55.615C21.0642 54.6578 21.2011 53.7625 21.91 52.9292L53.2308 16.1283C54.1536 15.0389 55.2764 14.1617 56.5992 13.4967C57.922 12.8322 59.297 12.5 60.7242 12.5C63.2586 12.5 65.4008 13.375 67.1508 15.125C68.9003 16.875 69.775 19.0211 69.775 21.5633V23.3333H65.9933V21.5517C65.9933 20.085 65.482 18.84 64.4592 17.8167C63.4364 16.7939 62.1914 16.2825 60.7242 16.2825C59.7753 16.2825 58.9195 16.4992 58.1567 16.9325C57.3939 17.3664 56.6345 18.0172 55.8783 18.885L52.3717 22.9492V52.2333C52.3717 53.5511 51.897 54.6836 50.9475 55.6308C49.9981 56.5775 48.8708 57.0508 47.5658 57.0508H23.7692ZM34.75 32.045L19.8975 17.16C21.812 15.81 24.0589 14.7578 26.6383 14.0033C29.2172 13.2489 31.8783 12.8717 34.6217 12.8717C36.955 12.8717 39.2583 13.155 41.5317 13.7217C43.8056 14.2878 46.0514 15.1028 48.2692 16.1667L34.75 32.045Z" fill="#0F0865"/>
        <path d="M23.7692 57.0508C22.6915 57.0508 21.9348 56.5722 21.4992 55.615C21.0642 54.6578 21.2012 53.7625 21.9101 52.9292L53.2309 16.1283C54.1537 15.0389 55.2765 14.1617 56.5992 13.4967C57.922 12.8322 59.297 12.5 60.7242 12.5C63.2587 12.5 65.4009 13.375 67.1509 15.125C68.9003 16.875 69.7751 19.0211 69.7751 21.5633V23.3333H65.9934V21.5517C65.9934 20.085 65.482 18.84 64.4592 17.8167C63.4365 16.7939 62.1915 16.2825 60.7242 16.2825C59.7753 16.2825 58.9195 16.4992 58.1567 16.9325C57.394 17.3664 56.6345 18.0172 55.8784 18.885L52.3717 22.9492V52.2333C52.3717 53.5511 51.897 54.6836 50.9476 55.6308C49.9981 56.5775 48.8709 57.0508 47.5659 57.0508H23.7692Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader heading={"Här är vi födda"} text={swedenString} />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <div style={{ display: "flex", flexDirection: "column", placeContent: "space-between", minWidth: "47%" }}>
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality1)}
                    marginBottom="24px"
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <DoubleBar
                    bar1={{
                      color: mainColor,
                      value: `${municipality1.pstring1}%`,
                      label: "Födda i Sverige",
                      height: inView ? `${municipality1.value1 > 0 ? height * municipality1.value1 / 100 : 0}px` : "0px",
                      lineColor: mainColor
                    }}
                    bar2={{
                      color: mainColor,
                      value: `${municipality1.pstring2}%`,
                      label: "Födda utomlands",
                      height: inView ? `${municipality1.value2 > 0 ? height * municipality1.value2 / 100 : 0}px` : "0px",
                      lineColor: mainColor
                    }}
                    inView={inView}
                  />
                </div>
              ) : (
                <div> </div>
              )}
              {municipality2 ? (
                <div style={{ display: "flex", flexDirection: "column", placeContent: "space-between", minWidth: "47%"}}>
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality2)}
                    marginBottom="24px"
                    color={secondaryColor}
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <DoubleBar
                    bar1={{
                      color: oppositeColor,
                      value: `${municipality2.pstring1}%`,
                      label: "Födda i Sverige",
                      height: inView ? `${municipality2.value1 > 0 ? height * municipality2.value1 / 100 : 0}px` : "0px",
                      lineColor: oppositeColor
                    }}
                    bar2={{
                      color: oppositeColor,
                      value: `${municipality2.pstring2}%`,
                      label: "Födda utomlands",
                      height: inView ? `${municipality2.value2 > 0 ? height * municipality2.value2 / 100 : 0}px` : "0px",
                      lineColor: oppositeColor
                    }}
                    inView={inView}
                  />
                </div>
              ) : (
                <SvgLayout>
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

BirthPlaceContainer.defaultProps = {
  data: [],
  sweden: {}
};

export default BirthPlaceContainer;
